import { useFormik } from "formik";
import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from 'react-select';

import { Enumeration } from "../../utils/interface";
import { formatEnumsForDropDown } from "../../utils/helperFunction";

interface NewPropertyRentModalFormProps {
  PropertyRentValidationSchema: any;
  propertyRentalTypes: Enumeration[];
  onCreatePropertyRent: (propertyRentInfo: any) => void;
}

const NewPropertyRentModalForm: React.FC<NewPropertyRentModalFormProps> = ({
  PropertyRentValidationSchema,
  propertyRentalTypes,
  onCreatePropertyRent,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => setShowModal(false);
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      rentalTypeEnumId: undefined,
      rentAmount: 0,
    },
    validationSchema: PropertyRentValidationSchema,
    onSubmit: (values, {resetForm}) => {
      onCreatePropertyRent(values);
      resetForm();
      handleModalClose();
    },
  });

  return (<>
    <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
      Add Rent
    </Button>
    <Modal show={showModal} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add New Rent</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="rental-type">
            <Form.Label><strong>Rental Type</strong></Form.Label>
            <Select
              options={formatEnumsForDropDown(propertyRentalTypes)}
              isSearchable
              placeholder=""
              onChange={(selectedOption) => {
                if (selectedOption) {
                  formik.setFieldValue('rentalTypeEnumId', selectedOption?.value)
                }
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="min-rent">
            <Form.Label><strong>Amount</strong></Form.Label>
            <Form.Control
              type="text"
              name="rentAmount"
              onChange={formik.handleChange}
              isInvalid={!!(formik.touched.rentAmount && formik.errors.rentAmount)}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.rentAmount}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>Close</Button>
        <Button variant="primary" onClick={() => formik.handleSubmit()}>Add</Button>
      </Modal.Footer>
    </Modal>
  </>);
};

export default NewPropertyRentModalForm;
